const pageBot = {
  title: 'Bot List',
  newBot: 'New Bot',
  deleteTitle: 'Delete the bot',
  deleteDescription: 'Are you sure to delete this bot?',
  robotConfig: {
    preCallSettingTitle: 'Pre-Call Setting',
    preCallSetting: {
      deleteConfirm: 'Are you sure delete this flow?'
    },
    preCallSettingDesc: 'Enable bot with knowledge and  automatic flow',
    speechSettingTitle: 'Model Setting',
    speechSettingDesc: 'Enable bot with  intelligence capabilities ',
    postCallSettingTitle: 'Post-Call Setting',
    postCallSettingDesc: 'Extract the information from the conversation',
    preCallSettingFlow: 'Flow',
    preCallSettingVariable: 'Variable',
    modelSettingLLM: 'LLM',
    modelSettingASR: 'ASR',
    modelSettingTTS: 'TTS',
    postCallSettingNER: 'NER',
    postCallSettingIntent: 'Intent',
    postCallSettingMultiLabel: 'Summary'
  },
  add: {
    // title: 'Bot Information',
    title: 'Robot',
    // msg: 'Enter a name and description for the bot that clearly communicates what the bot can do.',
    msg: 'Enter the name and description of the robot, clearly conveying what the robot can do.',
    // botName: 'Bot Name',
    botName: 'Name',
    botNameTooltip:
      'English or Arabic numbers or Underscore "_"',
    botType: 'Bot Type',
    globalTotalCallDuration: 'Global Total Call Duration',
    mockData: 'Mock Data',
    noteDescription: 'Note Description',
    descriptionPlaceholder:
      'Description of the robot',
    botNamePlaceholder: 'Please Enter Bot Name',
    mockDataTooltip:
      'It is mainly used to simulate data in real scenarios for use in the development and testing process.'
  },
  form: {
    variable: {
      variableName: 'VARIABLE NAME',
      type: 'TYPE',
      description: 'DESCRIPTION',
      upload: 'UPLOAD',
      required: 'REQUIRED'
    },
    config: {
      flow: {
        table: {
          title: 'Add {{key}}',
          subTitle: 'Select {{key}} and add it into your bot.',
          name: {
            title: 'Name',
            placeholder: 'name'
          },
          updateTime: {
            title: 'UpdateTime'
          },
          description: {
            title: 'Description'
          },
          add: 'Add'
        }
      }
    }
  }
}

export default pageBot
